export enum ELanguage {
    English = 0,
    Español = 1,
    Français = 2
}
